import { ComponentProps } from 'react';
import AntdRow from 'antd/es/row';

export default function Row(props: ComponentProps<typeof AntdRow>) {
    return <AntdRow {...props} />;
}
